import { createSelector } from '@ngrx/store';
import { AppFeatures, IAppState } from '../app.state';
import { ITeamsState } from './teams.state';
import { getUsers } from "../users/users.selectors";


export const getTeamsState = (state: IAppState) => state[AppFeatures.TEAMS];
export const getTeams = createSelector(getTeamsState, (state: ITeamsState) => {
    return Object.keys(state.teams)?.map(key => state.teams[key]);
});
export const getTeamByUserId = (userId: string) => createSelector(getTeams, (teams) => {
  return teams?.find(team => team?.members?.find(user => user?.user_id === userId));
});
export const isUserConta3 = (userId: string) => createSelector(getTeams, (teams) => {
  return teams?.filter(team => team?.isConta3 === '1')
    .some(team => team?.members?.find(user => user?.user_id === userId));
});
export const isJuridic = (userId: string) => createSelector(getTeams, (teams) => {
  return teams?.filter(team => team?.departament === 'JURIDIC')
    .some(team => team?.members?.find(user => user?.user_id === userId));
});

export const isUserTeamLead = (userId: string) => createSelector(getTeams, (teams) => {
  return teams?.some(team => team?.lead === userId);
});
export const isUserInItTeam = (userId: string) => createSelector(getTeams, (teams) => {
  return teams?.some(team => team?.isIt === '1' && team?.members?.some(member => member.id === userId));
});
export const getUserTeamLeader = (userId: string) => createSelector(getTeams, getUsers, (teams, users) => {
  const userTeams = teams?.filter(team => team.members.some(user => user.user_id === userId));
  return userTeams?.map(team => {
    return users?.find(user => user.user_id === team.lead);
  });
});
export const getTeamLeads = createSelector(getTeams, (teams) => {
  return teams?.map(team => team.members.find(user => user.user_id === team.lead));
});
export const getConta3Users = createSelector(getTeams, (teams) => {
  return teams?.find(team => team?.isConta3 === '1')?.['members'] || [];
});
export const getItUsers = createSelector(getTeams, (teams) => {
  return teams?.find(team => team?.isIt === '1')?.['members'] || [];
})
